import css from "./CatalogueItemPage.module.scss";
import React, { useState } from "react";
import { cartItem, cartItems, catalogueItem } from "assets/types";
import { useParams } from "react-router-dom";
import { ItemSize } from "components/UI/itemSize/ItemSize";
import { DirectionArrow } from "components/UI/directionArrow/DirectionArrow";
import { PriceBlock } from "components/UI/priceBlock/PriceBlock";
import { cartHandler } from "utils/cartHandler";
import {useSelector} from "react-redux";
import {RootState} from "store/store";

export const CatalogueItemPage = ({
  cartItems,
  getCartItems,
}: {
  cartItems: cartItems;
  getCartItems: (result: cartItems) => void;
}) => {
  const catalogueItems = useSelector((state: RootState) => state.catalogue);

  const [isAboutActive, setIsAboutActive] = useState(false);
  const [isListActive, setIsListActive] = useState(false);

  const params = useParams();

  const catalogueItem = catalogueItems.find(
    (el: catalogueItem) => el.barcode === params.id
  );

  const cartCount = cartItems.find(
    (el: cartItem) => el.info.barcode === params.id
  )?.count;

  return (
    <main data-testid="catalogueItemPage" className={css.page}>
      {catalogueItem ? (
        <div className={css.page__item}>
          <div className={css.page__left}>
            <img src={catalogueItem.image} alt="Catalogue item" />
          </div>
          <div className={css.page__right}>
            <div className={css.page__top}>
              <span>В наличии</span>
              <h3 className={css.page__title}>
                {catalogueItem.brand}
                <span> {catalogueItem.name}</span>
              </h3>
              <ItemSize
                sizeType={catalogueItem.sizeType}
                size={catalogueItem.size}
              />
            </div>
            <PriceBlock
              cartCount={cartCount}
              catalogueItem={catalogueItem}
              getCartAction={(action: "+" | "-" | "0") => {
                getCartItems(cartHandler(action, catalogueItem, cartItems));
              }}
            />
            <div className={css.page__info}>
              <span>
                Производитель:<span>{catalogueItem.company}</span>
              </span>
              <span>
                Бренд:<span>{catalogueItem.brand}</span>
              </span>
              <span>
                Артикул:<span>{catalogueItem.barcode}</span>
              </span>
              <span>
                Штрихкод:<span>{catalogueItem.barcode}</span>
              </span>
            </div>
            <div className={css.page__about}>
              <div>
                <button
                  onClick={() => {
                    setIsAboutActive((curr) => !curr);
                  }}
                >
                  <h3 style={{ opacity: isAboutActive ? ".2" : "1" }}>
                    Описание
                  </h3>
                  <DirectionArrow direction={isAboutActive ? "asc" : "desc"} />
                </button>
                {isAboutActive && <p>{catalogueItem.about}</p>}
              </div>
              <div className={css.page__line} />
              <div>
                <button
                  onClick={() => {
                    setIsListActive((curr) => !curr);
                  }}
                >
                  <h3 style={{ opacity: isListActive ? ".2" : "1" }}>
                    Характеристики
                  </h3>
                  <DirectionArrow direction={isListActive ? "asc" : "desc"} />
                </button>
                {isListActive && (
                  <div>
                    <span>
                      Назначение:<span>{catalogueItem.brand}</span>
                    </span>
                    <span>
                      Тип:<span>{catalogueItem.brand}</span>
                    </span>
                    <span>
                      Производитель:<span>{catalogueItem.company}</span>
                    </span>
                    <span>
                      Бренд:<span>{catalogueItem.brand}</span>
                    </span>
                    <span>
                      Артикул:<span>{catalogueItem.barcode}</span>
                    </span>
                    <span>
                      Штрихкод:<span>{catalogueItem.barcode}</span>
                    </span>
                    <span>
                      Вес:
                      <span>
                        {catalogueItem.size} {catalogueItem.sizeType}
                      </span>
                    </span>
                    <span>
                      Объем:
                      <span>
                        {catalogueItem.size} {catalogueItem.sizeType}
                      </span>
                    </span>
                    <span>
                      Кол-во в коробке:
                      <span>
                        {catalogueItem.size} {catalogueItem.sizeType}
                      </span>
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h1 className={css.page__notFound}>Товар не найден</h1>
      )}
    </main>
  );
};
